import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function useEditMentorProfile(props) {
  const [activeTab, setActiveTab] = useState(null);

  const location = useLocation();


  useEffect(() => {
    const handleActiveTab = () => {
      const activeTabName = location?.state && location.state?.activeTab;
      if (activeTabName) setActiveTab(activeTabName);
      else {
        setActiveTab("SkillsExperience");
      }
    };

    if (location) handleActiveTab(location?.state);
  }, [location]);

  return {
      activeTab,
  };
}
export default useEditMentorProfile;
